import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState } from 'react';
import { FormControl } from 'react-bootstrap';
const CompanyNumberFieldModal = _ref => {
  let {
    onHide,
    show,
    onSubmit
  } = _ref;
  const [companyNumber, setCompanyNumber] = useState('');
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(FormControl, {
      name: companyNumber,
      value: companyNumber,
      onChange: e => setCompanyNumber(e.target.value)
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: "Add Company Number",
    renderBody: () => modalBody(),
    onHide: onHide,
    onSubmit: () => {
      onSubmit(companyNumber);
    }
  });
};
export default CompanyNumberFieldModal;